import type { ModuleId, ModuleManifest } from '@buildex/module-contract';

/**
 * Реестр модулей платформы (§5).
 * Динамический import() → отдельный lazy-чанк на модуль:
 * неоплаченный модуль не скачивается браузером.
 *
 * Добавление нового модуля = новый пакет + одна строка здесь.
 * (При переходе на Module Federation меняется только этот файл, §12.)
 */
export const MODULE_LOADERS: Record<ModuleId, () => Promise<ModuleManifest>> = {
  pricing: () => import('@buildex/module-pricing').then((m) => m.manifest),
  dco: () => import('@buildex/module-dco').then((m) => m.manifest),
  sco: () => import('@buildex/module-sco').then((m) => m.manifest),
  planner: () => import('@buildex/module-planner').then((m) => m.manifest),
  marker: () => import('@buildex/module-marker').then((m) => m.manifest),
};
